// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".categories[data-v-0c743196]{display:grid;gap:20px;padding:0 0 25px}.categories--collapsed[data-v-0c743196]{grid-template-columns:repeat(3,minmax(-webkit-min-content,1fr));grid-template-columns:repeat(3,minmax(min-content,1fr));grid-template-rows:1fr;padding:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
